/**
 * react-slick marks off-screen and cloned slides with aria-hidden="true", but the links and
 * buttons inside them stay focusable, so keyboard users can tab into content screen readers skip
 * (WCAG 4.1.2). This keeps every focusable element inside a hidden slide out of the tab order
 * and restores its original tabindex once the slide becomes visible again.
 */
var SLIDE_SELECTOR = '.slick-slide';
var FOCUSABLE_SELECTOR = 'a[href], area[href], button, input, select, textarea, iframe, object, embed, audio[controls], video[controls], summary, [contenteditable], [tabindex]';
var ORIGINAL_TABINDEX_ATTR = 'data-slick-tabindex';
var NO_TABINDEX = 'none';

var syncSlide = function syncSlide(slide) {
  var isHidden = slide.getAttribute('aria-hidden') === 'true';

  if (isHidden) {
    slide.querySelectorAll(FOCUSABLE_SELECTOR).forEach(function (element) {
      var _element$getAttribute;

      if (element.hasAttribute(ORIGINAL_TABINDEX_ATTR)) return;
      element.setAttribute(ORIGINAL_TABINDEX_ATTR, (_element$getAttribute = element.getAttribute('tabindex')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : NO_TABINDEX);
      element.setAttribute('tabindex', '-1');
    });
  } else {
    slide.querySelectorAll("[".concat(ORIGINAL_TABINDEX_ATTR, "]")).forEach(function (element) {
      var originalTabindex = element.getAttribute(ORIGINAL_TABINDEX_ATTR);
      if (originalTabindex === NO_TABINDEX) element.removeAttribute('tabindex');else element.setAttribute('tabindex', originalTabindex);
      element.removeAttribute(ORIGINAL_TABINDEX_ATTR);
    });
  }
};

var collectSlides = function collectSlides(node, slides) {
  if (node.nodeType !== Node.ELEMENT_NODE) return;
  var parentSlide = node.closest(SLIDE_SELECTOR);
  if (parentSlide) slides.add(parentSlide);
  node.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide) {
    return slides.add(slide);
  });
};

export var initSlickAccessibility = function initSlickAccessibility() {
  if (!globalThis.document || !globalThis.MutationObserver) return;
  document.querySelectorAll(SLIDE_SELECTOR).forEach(syncSlide);
  var observer = new MutationObserver(function (mutations) {
    var slides = new Set();
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        if (mutation.target.matches(SLIDE_SELECTOR)) slides.add(mutation.target);
      } else {
        mutation.addedNodes.forEach(function (node) {
          return collectSlides(node, slides);
        });
      }
    });
    slides.forEach(syncSlide);
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
};